export enum InsafDeliveryEventType {
	ReturnToSba = "RETURN_TO_SBA",
	CompletionRequest = "COMPLETION_REQUEST",
	CompletionClosure = "COMPLETION_CLOSURE",
}
